import React from "react";
import ReactTooltip from "react-tooltip";

// Inject glow keyframes once
const STYLE_ID = "sync-dot-glow-style";
if (typeof document !== "undefined" && !document.getElementById(STYLE_ID)) {
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
        @keyframes syncDotGlow {
            0%, 100% { box-shadow: 0 0 1px 0.5px currentColor; }
            50% { box-shadow: 0 0 2px 1px currentColor; }
        }
    `;
    document.head.appendChild(style);
}

/**
 * Small glowing dot component indicating sync status.
 * Green = synced, Red/Orange = pending sync.
 */
export function SyncDot({ synced }) {
    const isSynced = synced === true;
    const color = isSynced ? "#50cd89" : "#f1416c";
    const tooltipText = isSynced
        ? "Synced with server"
        : "Pending sync";

    return (
        <>
            <ReactTooltip place="top" type="dark" effect="solid" />
            <span
                data-tip={tooltipText}
                style={{
                    display: "inline-block",
                    width: 4,
                    height: 4,
                    borderRadius: "50%",
                    backgroundColor: color,
                    color: color,
                    animation: "syncDotGlow 2s ease-in-out infinite",
                    flexShrink: 0,
                }}
            />
        </>
    );
}

/**
 * HOF that wraps any column formatter to prepend a sync status dot.
 * Usage: formatter: syncEnabled ? withSyncDot(HeaderColumnFormatter) : HeaderColumnFormatter
 */
export function withSyncDot(formatter) {
    return (cellContent, row, rowIndex, formatExtraData) => {
        const content = formatter
            ? formatter(cellContent, row, rowIndex, formatExtraData)
            : cellContent;

        return (
            <div className="d-flex align-items-center gap-2">
                <SyncDot synced={row.synced} />
                {content}
            </div>
        );
    };
}

/**
 * @deprecated Use withSyncDot on the first column instead of a separate column.
 */
export function SyncStatusColumnFormatter(cellContent, row) {
    const isSynced = row.synced === true;

    const iconClass = isSynced
        ? "fa fa-check-circle text-success fs-4"
        : "fa fa-times-circle text-danger fs-4";

    const tooltipText = isSynced
        ? "This record has been successfully synchronized with the server"
        : "This record is pending synchronization with the server";

    return (
        <div className="text-center">
            <ReactTooltip place="top" type="dark" effect="solid" />
            <i
                className={iconClass}
                data-tip={tooltipText}
            ></i>
        </div>
    );
}
